<ng-container *ngIf="orderDetail">
    <div class="modal-header border-0 pb-0">
        <h5 class="modal-title">View/Edit PO # {{orderDetail.poNumber}}</h5>
        <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
    </div>
    <div class="border-bottom p-3">
        <div class="mb-3">
            <a href="javascript:void(0);" class="btn btn-round btn-outline-black btn-sm" (click)="downloadPDF()"><i class="far fa-download"></i> Download PO</a>
            <a href="javascript:void(0);" class="btn btn-round btn-outline-black btn-sm ms-2" (click)="downloadEDI()" *ngIf="orderDetail.ediFileId"><i class="far fa-download"></i> Download EDI</a>
        </div>
        <div class="alert alert-danger mb-3" *ngIf="orderDetail.errorMessage">
            <div><span class="text-danger"><i class="fas fa-exclamation-triangle"></i></span> {{orderDetail.errorMessage}}</div>
        </div>
        <div class="d-flex align-items-center justify-content-start">
            <div class="me-4">
                <div class="mb-1">
                    {{orderDetail.accountName}}
                </div>
                <div>
                    {{orderDetail.entityName}} {{orderDetail.entityAddress}}
                </div>
            </div>
            <div>
                <div class="mb-1">
                    {{orderDetail.vendorName}}
                </div>
                <div>
                    #{{orderDetail.vendorAccountNumber}}
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <!-- order progress -->
        <div class="orderProgressContained">
            <div class="orderProgress mt-2 mb-4">
                <div class="stepper-wrapper">

                    <div class="stepper-item" *ngFor="let status of orderDetail.statusUpdates" [ngClass]="{'completed': status.isComplete}">
                        <div class="step-counter" [ngStyle]="!status.isComplete ? {'border': '1px solid #BCBCBC'} : {}">
                            <i class="far fa-box" *ngIf="!status.isComplete"></i>
                            <div class="avatar avatar-sm" *ngIf="status.isComplete && !status.backgroundImage">{{status.userInitials}}</div>
                            <div class="avatar avatar-sm" *ngIf="status.isComplete && status.backgroundImage" [ngStyle]="{'background-image': status.backgroundImage}"></div>
                            <span class="statusIcon" *ngIf="status.isComplete">
                                <span class="fa-stack fa-2x">
                                    <i class="fad fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-check fa-stack-1x fa-inverse"></i>
                                </span>
                            </span>
                            <span class="statusIcon" *ngIf="!status.isComplete">
                                <span class="fa-stack fa-2x">
                                    <i class="fad fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-hourglass-half fa-stack-1x fa-inverse"></i>
                                </span>
                            </span>
                        </div>
                        <div class="step-name">
                            <div class="stepText" *ngIf="!status.isComplete">
                                <div class="text-muted">{{status.displayString}}</div>
                            </div>
                            <div class="stepText" *ngIf="status.isComplete">
                                <div class="fw-bold mb-1" *ngIf="status.userName">{{status.displayString}} by {{status.userName}}</div>
                                <div class="fw-bold mb-1" *ngIf="!status.userName">{{status.displayString}}</div>
                                <div class="line-height-1"><small>On {{status.dateTimeMilliseconds | localPrettyDate}}</small></div>
                                <small class="line-height-1 text-muted">{{status.dateTimeMilliseconds | localPrettyTime}}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- search bar -->
        <div class="orderCard">
            <div class="customSearch">
                <div class="input-group input-group-lg box-shadow-none">
                    <input type="text" class="form-control" placeholder="search items..." aria-label="search items" aria-describedby="search-items" [(ngModel)]="searchString">
                    <div class="input-group-append">
                        <button class="btn btn-lg btn-outline-dark" type="button"><i class="fas fa-search fa-lg"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <!-- order table -->
        <div class="mt-3 admin-order-table">
            <table class="table orderTable mb-0">
                <thead>
                    <tr>
                        <th>Description</th>
                        <!-- inline styles for col widths -->
                        <th class="text-left" style="width: 75px;">UOM</th>
                        <th class="text-left" style="width: 75px;">Qty</th>
                        <th class="text-left"></th>
                        <th class="text-left nowrap" style="width: 75px;">Price per Unit</th>
                        <th class="text-right">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- LINE ITEM -->
                    <ng-container *ngFor="let item of orderDetail.items | search: searchString; let idx = index">

                        <tr [ngClass]="{'editedItem': item.editDetail}">
                            <td>
                                <div class="d-flex align-items-start justify-content-start m-100">
                                    <div class="image m-100">
                                        <img [src]="item.imageUrl" class="productImg">
                                    </div>
                                    <div class="m-100">
                                        <h5 class="mb-1">{{item.displayName}}</h5>
                                        <div class="mb-2">
                                            <span class="productFormulary" *ngIf="item.isFormulary"><i class="far fa-check"></i> Formulary</span>
                                            <span class="productNonFormulary" *ngIf="!item.isFormulary"><i class="far fa-times"></i> Non Formulary</span>
                                            <span><span class="mx-1">•</span> Item #{{item.vendorItemNumber}}</span>
                                            <span *ngIf="item.manufacturerName || item.manufacturerPartNumber"><span class="mx-1">•</span> Mfr.: {{item.manufacturerName}} #{{item.manufacturerPartNumber}}</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-left">
                                {{item.selectedUOM.uom}}
                            </td>
                            <td class="text-left">
                                <form novalidate #fQuantity="ngForm" [ngClass]="{'was-validated': item.submitAttempt}">
                                    <input type="number" class="form-control qtyInput" placeholder="" ng-min="0" name="quantity" required [(ngModel)]="item.quantity" [disabled]="!orderDetail.canEdit" (ngModelChange)="item.showUpdate = true" />
                                </form>
                            </td>
                            <td class="">
                                <div class="row g-2 align-items-center">
                                    <div class="col-8">
                                        <input type="text" class="form-control" placeholder="Note (optional)" name="updateNotes" [(ngModel)]="item.updateNotes" [disabled]="!orderDetail.canEdit" (ngModelChange)="item.showUpdate = (item.editDetail != null)" />
                                    </div>
                                    <div class="col-4">
                                        <button type="button" class="btn btn-primary btn-sm text-strong" *ngIf="item.showUpdate" (click)="submitUpdate(fQuantity, fPrice, item, idx)">Update</button>
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">
                                <form novalidate #fPrice="ngForm" [ngClass]="{'was-validated': item.submitAttempt}">
                                    <input type="number" class="form-control qtyInput" placeholder="" ng-min="0" name="quantity" step="0.01" required [ngModel]="item.price | number:'1.2-2'" (ngModelChange)="item.price = $event; item.showUpdate = true;" [ngModelOptions]="{updateOn: 'blur'}" [disabled]="!orderDetail.canEdit" />
                                </form>
                            </td>
                            <td class="text-right">
                                {{item.subTotal | currency}}
                            </td>
                        </tr>


                        <!-- edited item updates-->
                        <tr *ngIf="item.editDetail">
                            <td>
                                <div class="text-danger">
                                    <i class="far fa-info-circle"></i> Edited {{item.editDetail.editDateTimeMilliseconds | localDate}}:
                                </div>
                            </td>
                            <td>
                                <div class="fst-italic" *ngIf="item.editDetail.uom">
                                    was: {{item.editDetail.uom}}
                                </div>
                            </td>
                            <td>
                                <div class="fst-italic" *ngIf="item.editDetail.quantity">
                                    was: {{item.editDetail.quantity}}
                                </div>
                            </td>
                            <td>
                                <div *ngIf="item.editDetail.notes">
                                    {{item.editDetail.notes}}
                                </div>
                            </td>
                            <td>
                                <div class="fst-italic" *ngIf="item.editDetail.price">
                                    was: {{item.editDetail.price | currency}}
                                </div>
                            </td>
                            <td>
                                &nbsp;
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>